import { types } from "./TickerDisplay.actions";
import { InGameMessage } from "./TickerDisplay.actions";

export interface ITickerDisplayStateProps {
  message: string | InGameMessage[];
  hidden?: boolean;
  animationStopped?: boolean;
}

const defaultState: ITickerDisplayStateProps = {
  message: "",
  hidden: true,
  animationStopped: false
};

export const ticker = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_TICKER_HIDDEN:
      return {
        ...state,
        hidden: typeof action.value === "boolean" ? action.value : state.hidden
      };
    case types.SET_ANIMATION_STOPPED:
      return {
        ...state,
        animationStopped:
          typeof action.value === "boolean"
            ? action.value
            : state.animationStopped
      };
    case types.SET_TICKER_MESSAGE:
      return { ...state, message: action.value };
    default:
      return state;
  }
};
